import * as R from 'ramda'
export const getOrgWorkspaces = R.pathOr({}, ['workspaces', 'workspace'])
